import {useState,useEffect,useRef} from 'react'; 
import  Bredcrum  from '../../components/bredcrum';
import { Tag } from 'primereact/tag';
import {Tablescom} from '../../components/tablescomp';
import {userservices} from '../../services/userServices';
import {productservices} from '../../services/productServices';
import {supplierservices} from "../../services/supplierServices";
import {manufacturingServices} from "../../services/manufacturingServices";
import {Titlebar,Searchbox, Confirmdelete} from  '../../components/fieldsComp';
import { BrowserRouter, Routes, Route, useNavigate   } from "react-router";
import { Dialog } from 'primereact/dialog';
import {localurl} from '../../constant';
import {convertFileToBase64} from '../../helpers/base64conversion';
import { Toast } from "primereact/toast";
const Manufacturing = () =>{

    const navigate = useNavigate();
    const [users,setUsers] = useState([]);
    const [results,setResults] = useState([]);
    const [userloaded,setUserloaded] = useState(true);
    const [visible,setVisible] = useState(false);
    const [popvisible,setPopvisible] = useState(false);
    const [deleleteid,setDeleleteid] = useState(false);
    const [viewmanufacturing,setViewmanufacturing] = useState([]);
    const [viewvisible,setViewvisible] = useState(false);
    const toast = useRef(null);
    const [quickFilterText, setQuickFilterText] = useState('');
    const [totalRows, setTotalRows] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize, setPageSize] = useState(5); // 🔄 dynamic page size

    useEffect(()=>{
        getallmanufacturing(currentPage,pageSize);
    },[currentPage,pageSize]); 

    useEffect(() => {
    setColDefs(getColDefs(currentPage, pageSize));
    }, [currentPage, pageSize]);


    const handleNext = () => {
    if (currentPage < Math.ceil(totalRows / pageSize)) {
      setCurrentPage(currentPage + 1);
    }
  };

  const handlePrevious = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };
    const deletemanufacturing = (id) =>{
         setPopvisible(true);
         setDeleleteid(id);
      }

const getColDefs = (currentPage, pageSize) => [
  {
    headerName: "SR NO",
    valueGetter: (params) => {
      return ((currentPage - 1) * pageSize) + params.node.rowIndex + 1;
    },
  },
    { headerName: "Order Id",field: "order_id" },
    { headerName: "Poduct id",field: "product_id" },
    { headerName: "Product Name",field: "product_name" },
     { headerName: "Status",field: "status" },
    // { headerName: "Status",field: "status",cellRenderer: (params) => {
    //     return (
    //       params.getValue()==1 ?'Active':'De-active'
         
    //     );
    //   } },
    // { headerName: "Phone",field: "phone" },
    // { headerName: "Supplier type",field: "type" },
    // { headerName: "Freight Charges",
       
    //     field: "name" },
    // { headerName: "Notes",field: "total_stock_used_across_products" },
    
    
    { headerName: "Action",
    cellRenderer: (params) => {
      // console.log("params");
      // console.log(params.data.id);
      return (
        <>
             <button class="btn  btn-xs btn-primary btn-border-none custom-btn-color2" onClick={(e) => editredirect(params.data.id,params.data)}><i class="icon icon-note icon-style color-white"></i></button>
             &nbsp;
             <button class="btn btn-danger btn-xs btn-white btn-border-none" onClick={(e) => deletemanufacturing(params.data.id)} ><i class="icon icon-trash icon-style color-white"></i></button> 
             &nbsp;
             <button class="btn btn-success btn-xs btn-white btn-border-none" onClick={(e) => viewmanufacturingdata(params.data.id)}><i class="icon icon-eye icon-style color-white"></i></button> 
        </>
       
      );
    } }
];

const [colDefs, setColDefs] = useState(getColDefs(1, 5));
      
  // const [colDefs, setColDefs] = useState([
  //   { headerName: "SR NO",
  //     valueGetter: (params) => params.node.rowIndex + 1,
  //   },
  //   { headerName: "Order Id",field: "order_id" },
  //   { headerName: "Poduct id",field: "product_id" },
  //   { headerName: "Product Name",field: "product_name" },
  //    { headerName: "Status",field: "status" },
  //   // { headerName: "Status",field: "status",cellRenderer: (params) => {
  //   //     return (
  //   //       params.getValue()==1 ?'Active':'De-active'
         
  //   //     );
  //   //   } },
  //   // { headerName: "Phone",field: "phone" },
  //   // { headerName: "Supplier type",field: "type" },
  //   // { headerName: "Freight Charges",
       
  //   //     field: "name" },
  //   // { headerName: "Notes",field: "total_stock_used_across_products" },
    
    
  //   { headerName: "Action",
  //   cellRenderer: (params) => {
  //     // console.log("params");
  //     // console.log(params.data.id);
  //     return (
  //       <>
  //            <button class="btn  btn-xs btn-primary btn-border-none custom-btn-color2" onClick={(e) => editredirect(params.data.id,params.data)}><i class="icon icon-note icon-style color-white"></i></button>
  //            &nbsp;
  //            <button class="btn btn-danger btn-xs btn-white btn-border-none" onClick={(e) => deletemanufacturing(params.data.id)} ><i class="icon icon-trash icon-style color-white"></i></button> 
  //            &nbsp;
  //            <button class="btn btn-success btn-xs btn-white btn-border-none" onClick={(e) => viewmanufacturingdata(params.data.id)}><i class="icon icon-eye icon-style color-white"></i></button> 
  //       </>
       
  //     );
  //   } }
  // ]);

  const editredirect = (id,Data) =>{
    navigate(`/editmanufacturing/${id}`, { state: { manufacturing: Data } });
  }


  const getallmanufacturing  = (page,pageSize)=> {
        setUserloaded(true);
        manufacturingServices.getmanufacturing(page,pageSize).then((response)=>{
            if(response.status == 200){
                setResults(response.data.data);
                setTotalRows(response.data.total);
                setCurrentPage(response.data.current_page);
                setUserloaded(false);
            }else{
                setResults([]);
                // setUsers([]);
                // setUserloaded(true);
            }  
        }).catch((error)=>{
          setResults([]);
            // setUsers([]);
            // setUserloaded(true);
        }); 
  } 

  const addproductnavigate = () =>{
    // navigate.  
    navigate('/addingredient');
  }

  const uploadmanufacturing = async (e) =>{
     e.preventDefault(); 
     let file =  e.target.file.files[0];
     const base64 = await convertFileToBase64(file);
     supplierservices.createmultisupplier(base64).then((response)=>{

     }).catch((error)=>{
       
     });        
  }

  const viewmanufacturingdata = (id) =>{
        manufacturingServices.getmanufacturing(id).then((response)=>{
          if(response.status == 200){
            setViewmanufacturing(response.data.data);
            setViewvisible(true);
          }
      }).catch((error)=>{
        
      }); 
   }

    const deletemanufacturingdata = () => {
            if(deleleteid){
            manufacturingServices.deletemanufacturing(deleleteid).then((response)=>{
            if(response.status == 200){
              setPopvisible(false);
              setDeleleteid(false);
              toast.current.show({ severity: 'success', summary: 'Sale', detail: 'Manufacturing deleted successfully' }); 
              getallmanufacturing(currentPage,pageSize);   
            }
        }).catch((error)=>{
          
        }); 
            }

    }

    const handlePageSizeChange = (e) => {
    const newSize = parseInt(e.target.value);
    setPageSize(newSize);
    setCurrentPage(1);           // reset to page 1
    getallmanufacturing(1, newSize);       // reload with new size
  };
    const onPaginationChanged = (params) => {
    const gridApi = params.api;
    const newPage = gridApi.paginationGetCurrentPage() + 1;
    if (newPage !== currentPage) {
      setCurrentPage(newPage);
    }
  };
    const canceldiag = () =>{
        setPopvisible(false);
    }
  return(
       <>
       <Toast ref={toast} />
          <Bredcrum title={'Product'} divider={false}/>
      <Confirmdelete popvisible={popvisible} deletefun={deletemanufacturingdata} cancel={canceldiag} title="Manufacturing" />
          
      {/* <Dialog
            header="⚠️ Confirm Deletion"
            visible={popvisible}
            style={{ width: '30vw', borderRadius: '10px' }}
            onHide={() => setPopvisible(false)}
            modal
          >
        <p className="mb-4" style={{ fontSize: '1rem' }}>
          Are you sure you want to delete this manufacturing?
        </p>

        <div className="d-flex justify-content-end gap-2">
          <button
            className="btn btn-secondary rounded-pill px-4"
            onClick={() => setPopvisible(false)}
          >
            Cancel
          </button>
          <button
            className="btn btn-danger rounded-pill px-4"
            onClick={deletemanufacturingdata}
          >
            Delete
          </button>
        </div>
      </Dialog> */}

    <Dialog 
  header="Manufacturing Data View"
  visible={viewvisible}
  style={{ width: '60vw' }}
  onHide={() => setViewvisible(false)}
  // footer={footerContent}
  modal
  className="p-fluid"
>
  <div className="card-body">
    <div className="container mt-4">
      {viewmanufacturing.map((row, index) => (
          <div className="row" key={index}>
              {/* Name */}
              <div className="col-md-6 form-group">
                <label>Order ID</label>
                <input
                  type="text"
                  name="order_id"
                  className="form-control"
                  value={row.order_id || ''} readOnly
                />
              </div>

                      {/* Email */}
                      <div className="col-md-6 form-group">
                        <label>Product Name</label>
                        <input
                          type="text"
                          name="product_name"
                          className="form-control"
                          value={row.product_name || ''} readOnly
                        />
                      </div>

                      {/* Phone */}
                      <div className="col-md-6 form-group">
                        <label>Quantity To Produce</label>
                        <input
                          type="text"
                          name="quantity_to_produce"
                          className="form-control"
                          value={row.quantity_to_produce || ''} readOnly
                        />
                      </div>

                      {/* Address */}
                      <div className="col-md-6 form-group">
                        <label>Created Date</label>
                        <input
                          type="date"
                          name="date"
                          className="form-control"
                          value={row.date || ''} readOnly
                        />
                      </div>

                      {/* Shop Name */}
                      <div className="col-md-6 form-group">
                        <label>Start Date</label>
                        <input
                          type="date"
                          name="start_date"
                          className="form-control"
                          value={row.start_date || ''} readOnly
                        />
                      </div>

                      <div className="col-md-6 form-group">
                        <label>End Date</label>
                        <input
                          type="date"
                          name="end_date"
                          className="form-control"
                          value={row.end_date || ''} readOnly
                        />
                      </div>

                      <div className="col-md-6 form-group">
                        <label>Status</label>
                        <input
                          type="text"
                          name="status"
                          className="form-control"
                          value={row.status || ''} readOnly
                        />
                      </div>


                      {/* Type */}
                      <div className="col-md-6 form-group">
                        <label>Manufacture Name</label>
                        <input
                          type="text"
                          name="manufacture_id"
                          className="form-control"
                          readOnly
                          value={row.manufacture_id || ''} 
                        />
                      </div>

                    <div className="col-md-12 form-group">
                        <label>remarks</label>
                        <textarea name="remarks" className="form-control" readOnly>
                          {row.remarks || ''}
                        </textarea>
                      </div>

                    </div>
      ))}
    </div>
  </div>
    </Dialog>

          <div class="row">
              <div className='col-md-12 mb-4 mt-4'>
                 <div className='flex-box flex-between'>
                     <div className=''>
                         <button className='btn btn-primary rounded-pill custom-btn-color custom-btn-br-color ps-5 pe-5' onClick={() => navigate('/addmanufacturing')}>Add Manufacturing</button> 
                         &nbsp;
                         &nbsp;
                         &nbsp; 

                         {/* <button className='btn rounded-pill btn-dark custom-btn-br-color ps-5 pe-5' onClick={() => setVisible(true)}>Add Multi Suppliers</button>  */}

                         {/* <Dialog visible={visible} position='top' modal style={{ width: '50rem' }} onHide={() => {if (!visible) return; setVisible(false); }}>
                             <div class="container">
                                  <h2>Excel Upload & Download</h2>
                                     <a href={localurl+"/storage/templates/supplier.xls"} download class="btn text-primary">Click to Download Excel Template</a>

                                  <form id="uploadForm" onSubmit={(e) => uploadmanufacturing(e)}>
                                    <label for="file">Upload Excel File:</label><br/>
                                    <input type="file" id="file" name="file" accept=".xlsx, .xls" required/><br/>
                                    <button type="submit" class="btn">Upload</button>
                                  </form>
                                 <div id="status" class="status"></div>
                                </div>
                        </Dialog> */}

                <Dialog visible={visible} position='top' modal style={{ width: '50rem' }} onHide={() => {if (!visible) return; setVisible(false); }}>
                  <div className="container py-5">
                    <div className="card shadow-lg rounded-4 p-4">
                      <h2 className="mb-4 text-center text-primary">Excel Multiple Data Upload</h2>

                      <div className="text-center mb-4">
                        <a
                          href={localurl + "/templates/component.xlsx"}
                          download
                          className="btn btn-outline-primary rounded-pill px-4"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          Download Excel Template
                        </a>
                      </div>

                      <form id="uploadForm" onSubmit={(e) => uploadmanufacturing(e)}>
                        <div className="mb-3">
                          <label htmlFor="file" className="form-label fw-semibold">
                            Upload Excel File
                          </label>
                          <input
                            type="file"
                            className="form-control form-control-lg"
                            id="file"
                            name="file"
                            accept=".xlsx, .xls"
                            required
                          />
                        </div>

                        <div className="text-center">
                          <button
                            type="submit"
                            className="btn btn-primary rounded-pill px-5 py-2 custom-btn-color"
                          >
                            Upload
                          </button>
                        </div>
                      </form>

                      <div id="status" className="status mt-4 text-center text-success fw-medium"></div>
                    </div>
                  </div>

              </Dialog>
                      </div>
                     
                      <Searchbox value={quickFilterText} onChange={(e) => setQuickFilterText(e.target.value)} />
                  </div> 
              </div> 
             
              
              <Titlebar text={'Manufacturing List'}/>
              <div className="col-md-12 mt-3">
                  <div className='card'>
                    <div className='card-body card-body-style'>
                     <Tablescom rowdata={results} coldefs={colDefs} isloaded={userloaded} quickFilterText={quickFilterText}
                     paginationPageSize={pageSize} onPaginationChanged={onPaginationChanged}
                     totalRows={totalRows} currentPage={currentPage} pageSize={pageSize} handleNext={handleNext} 
                     handlePrevious={handlePrevious}
                     handlePageSizeChange={handlePageSizeChange}/>
                     </div>
                 </div>
              </div>   
          </div>
       </>
    );   
 }
 export default Manufacturing;